<template>
  <div :class="className" :id="id" style="height: 100%;width: 100%;"></div>
</template>

<script>
export default {
  name: 'barChart',
  props: {
    className: {
      type: String,
      default: 'chart',
    },
    id: {
      type: String,
      default: 'chart',
    },
    width: {
      type: String,
      default: '200px',
    },
    height: {
      type: String,
      default: '200px',
    },
    barxAxisData: {
      type: Array,
    },
    barSeriesData: {
      type: Array,
    },
    isClickAble: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      chart: null,
    };
  },
  mounted() {
    this.initChart();
  },
  beforeDestroy() {
    if (!this.chart) {
      return;
    }
    this.chart.dispose();
    this.chart = null;
  },
  methods: {
    initChart() {
      this.chart = echarts.init(document.getElementById(this.id));
      this.chart.setOption({
        title: {
          text: this.title,
          x: 'center',
        },
        color: ['#3398DB'],
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow',
          },
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '8%',
          containLabel: true,
        },
        dataZoom: [
          {
            show: true,
            start: 0,
          },
        ],
        xAxis: [
          {
            type: 'category',
            data: this.barxAxisData,
            axisTick: {
              alignWithLabel: true,
            },
          },
        ],
        yAxis: [
          {
            type: 'value',
          },
        ],
        series: [
          {
            name: '操作',
            type: 'bar',
            barWidth: '60%',
            data: this.barSeriesData,
          },
        ],
      });
      let _this = this;
      window.addEventListener('resize', () => {
        _this.chart.resize();
      });
      if (_this.isClickAble) {
        _this.chart.on('click', (params) => { // 点击柱形图调用
          this.$emit('getOperateLogDepartPie', params);
        });
      }
    },
  },
};
</script>
